import {
    sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest
} from "@/helper/requests";
import admin from "@/urls/roles/admin";
import selectors from "@/urls/selectors";
import guard from "@/urls/roles/guard";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    loadOrganizationSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.ORDERS.ORGANIZATIONS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadTerritoriesSelector: ({commit}, {url, gets, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.ORDERS.TERRITORIES({},gets)
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadBuildingsSelector: ({commit}, {url, gets, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.ORDERS.BUILDINGS({},gets)
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadRoomsSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.ORDERS.ROOMS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadCarsSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.CARS.CARS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadCarsModelsSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.CARS.MODELS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadUsersVisitorsSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.USERS.VISITORS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadSubordinatesSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.ORDERS.SUBORDINATES()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadOrganizationsSelector: ({commit}, {url, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.VISITORS.ORGANIZATIONS()
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadPostsSelector: ({commit}, {url, gets, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.POSTS.NAMES(gets)
        sendGetRequest(
            url, finalizer, catcher
        )
    },
    loadDepartmentsSelector: ({commit}, {url, gets, finalizer, catcher}) => {
        if (!url) url = selectors.SELECTORS.DEPARTMENTS.ALL(gets)
        sendGetRequest(
            url, finalizer, catcher
        )
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
